import React from 'react'
import Select from 'react-select'
import { get, some, every, isEmpty, filter, isPresent } from 'lodash'

const filteredData = ({ clusters, filters }) => filter(clusters, (cluster) => {
  const filterResults = {}

  if (filters.sites != 'all') {
    filterResults['sites'] = some(filters.sites, site => site.value === get(cluster, 'site.code'))
  }

  if (filters.inSite != 'all') {
    filterResults['inSite'] = isPresent(cluster.site) === filters.inSite
  }

  return (every(filterResults, (value, _key) => value === true) || isEmpty(filterResults))
})

const ClusterReportFilters = ({ filters, changeFilters, filterOptions }) => (
  <div className="container-fluid" style={{ marginTop: '10px', marginBottom: '10px' }}>
    <div className="row">
      <div className="col col-2">
        <label htmlFor="inSiteFilter">
          Matched to site:
          <div className="input-group">
            <div className="input-group-prepend">
              <div className="input-group-text">
                <input
                  type="radio"
                  name="inSiteFilterAll"
                  id="inSiteFilterAll"
                  checked={filters.inSite === 'all'}
                  onClick={_ => changeFilters({ ...filters, inSite: 'all' })}
                />
                <span style={{ marginLeft: '5px' }}>All</span>
              </div>
            </div>
            <div className="input-group-prepend">
              <div className="input-group-text">
                <input
                  type="radio"
                  name="inSiteFilterTrue"
                  id="inSiteFilterTrue"
                  checked={filters.inSite === true}
                  onClick={_ => changeFilters({ ...filters, inSite: true })}
                />
                <span style={{ marginLeft: '5px' }}>True</span>
              </div>
            </div>
            <div className="input-group-prepend">
              <div className="input-group-text">
                <input
                  type="radio"
                  name="inSiteFilterFalse"
                  id="inSiteFilterFalse"
                  checked={filters.inSite === false}
                  onClick={_ => changeFilters({ ...filters, inSite: false })}
                />
                <span style={{ marginLeft: '5px' }}>False</span>
              </div>
            </div>
          </div>
        </label>
      </div>
    </div>

    <div className='row'>
      <div className="col">
        Site
        <Select
          id='vmsSiteFilter'
          isMulti
          value={filters.sites}
          options={filterOptions.sites}
          onChange={options => {
            let sites = options
            if (isEmpty(options)) { sites = 'all' }

            changeFilters({ ...filters, sites })
          }}
        />
      </div>
    </div>
  </div>
)

export { ClusterReportFilters, filteredData }
